(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-start/assets/tracking.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-start/assets/tracking.js');
"use strict";

const {
  trackEvent
} = svs.components.analytics;
setGlobal('svs.lyckoplatsen.page_start', {
  trackClickPlayLyckoplatsen: isCTAPrimary => {
    trackEvent({
      category: 'Lyckoplatsen',
      action: isCTAPrimary ? 'CTA_primär' : 'CTA_sekundär',
      opt_label: 'Välj lyckoplats själv'
    });
  },
  trackClickPlayHomeAddress: () => {
    trackEvent({
      category: 'Lyckoplatsen',
      action: 'CTA_sekundär',
      opt_label: 'Spela på din hemadress'
    });
  }
});

 })(window);